"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBaseTrackModel = exports.getCompatibleDisplays = void 0;
var mobx_1 = require("mobx");
var mobx_state_tree_1 = require("mobx-state-tree");
// locals
var configuration_1 = require("../../configuration");
var util_1 = require("../../util");
var types_1 = require("../../util/types");
var mst_1 = require("../../util/types/mst");
function getCompatibleDisplays(self) {
  var _ref = (0, util_1.getEnv)(self),
    pluginManager = _ref.pluginManager;
  var view = (0, util_1.getContainingView)(self);
  var viewType = pluginManager.getViewType(view.type);
  var compatTypes = viewType.displayTypes.map(function (d) {
    return d.name;
  });
  var displays = self.configuration.displays;
  return displays.filter(function (d) {
    return compatTypes.includes(d.type);
  });
}
exports.getCompatibleDisplays = getCompatibleDisplays;
/**
 * #stateModel BaseTrackModel
 * these MST models only exist for tracks that are *shown*. they should contain
 * only UI state for the track, and have a reference to a track configuration.
 * note that multiple displayed tracks could use the same configuration.
 */
function createBaseTrackModel(pm, trackType, baseTrackConfig) {
  return mobx_state_tree_1.types.model(trackType, {
    /**
     * #property
     */
    id: mst_1.ElementId,
    /**
     * #property
     */
    type: mobx_state_tree_1.types.literal(trackType),
    /**
     * #property
     */
    configuration: (0, configuration_1.ConfigurationReference)(baseTrackConfig),
    /**
     * #property
     */
    minimized: false,
    /**
     * #property
     */
    displays: mobx_state_tree_1.types.array(pm.pluggableMstType('display', 'stateModel'))
  }).views(function (self) {
    return {
      /**
       * #getter
       * determines which webworker to send the track to, currently based on trackId
       */
      get rpcSessionId() {
        return self.configuration.trackId;
      },
      /**
       * #getter
       */
      get name() {
        return (0, configuration_1.getConf)(self, 'name');
      },
      /**
       * #getter
       */
      get textSearchAdapter() {
        return (0, configuration_1.getConf)(self, 'textSearchAdapter');
      },
      /**
       * #getter
       */
      get adapterType() {
        var adapterConfig = (0, configuration_1.getConf)(self, 'adapter');
        if (!adapterConfig) {
          throw new Error("no adapter configuration provided for ".concat(self.type));
        }
        var adapterType = pm.getAdapterType(adapterConfig.type);
        if (!adapterType) {
          throw new Error("unknown adapter type ".concat(adapterConfig.type));
        }
        return adapterType;
      },
      /**
       * #getter
       */
      get viewMenuActions() {
        return self.displays.map(function (d) {
          return d.viewMenuActions;
        }).flat();
      },
      /**
       * #getter
       */
      get canConfigure() {
        var session = (0, util_1.getSession)(self);
        return (0, types_1.isSessionModelWithConfigEditing)(session) && (
        // @ts-ignore
        session.adminMode ||
        // @ts-ignore
        session.sessionTracks.find(function (track) {
          return track.trackId === self.configuration.trackId;
        }));
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setMinimized: function setMinimized(flag) {
        self.minimized = flag;
      },
      /**
       * #action
       */
      activateConfigurationUI: function activateConfigurationUI() {
        var session = (0, util_1.getSession)(self);
        var view = (0, util_1.getContainingView)(self);
        if ((0, types_1.isSessionModelWithConfigEditing)(session)) {
          // @ts-ignore
          var trackConf = session.editTrackConfiguration(self.configuration);
          if (trackConf && trackConf !== self.configuration) {
            view.hideTrack(self.configuration);
            view.showTrack(trackConf);
          }
        }
      },
      /**
       * #action
       */
      showDisplay: function showDisplay(displayId) {
        var initialSnapshot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var schema = pm.pluggableConfigSchemaType('display');
        var conf = (0, mobx_state_tree_1.resolveIdentifier)(schema, (0, mobx_state_tree_1.getRoot)(self), displayId);
        var displayType = pm.getDisplayType(conf.type);
        if (!displayType) {
          throw new Error("unknown display type ".concat(conf.type));
        }
        var display = displayType.stateModel.create(_objectSpread({}, initialSnapshot, {
          type: conf.type,
          configuration: conf
        }));
        self.displays.push(display);
      },
      /**
       * #action
       */
      hideDisplay: function hideDisplay(displayId) {
        var schema = pm.pluggableConfigSchemaType('display');
        var conf = (0, mobx_state_tree_1.resolveIdentifier)(schema, (0, mobx_state_tree_1.getRoot)(self), displayId);
        var t = self.displays.filter(function (d) {
          return d.configuration === conf;
        });
        (0, mobx_1.transaction)(function () {
          return t.forEach(function (d) {
            return self.displays.remove(d);
          });
        });
        return t.length;
      },
      /**
       * #action
       */
      replaceDisplay: function replaceDisplay(oldId, newId) {
        var initialSnapshot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var idx = self.displays.findIndex(function (d) {
          return d.configuration.displayId === oldId;
        });
        if (idx === -1) {
          throw new Error("could not find display id ".concat(oldId, " to replace"));
        }
        var schema = pm.pluggableConfigSchemaType('display');
        var conf = (0, mobx_state_tree_1.resolveIdentifier)(schema, (0, mobx_state_tree_1.getRoot)(self), newId);
        var displayType = pm.getDisplayType(conf.type);
        if (!displayType) {
          throw new Error("unknown display type ".concat(conf.type));
        }
        self.displays.splice(idx, 1, _objectSpread({}, initialSnapshot, {
          type: conf.type,
          configuration: conf
        }));
      }
    };
  }).views(function (self) {
    return {
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        var menuItems = self.displays.map(function (d) {
          return d.trackMenuItems();
        }).flat();
        var shownId = self.displays[0].configuration.displayId;
        var compatDisp = getCompatibleDisplays(self);
        return [].concat(_toConsumableArray(menuItems), _toConsumableArray(compatDisp.length > 1 ? [{
          type: 'subMenu',
          label: 'Display types',
          subMenu: compatDisp.map(function (d) {
            return {
              type: 'radio',
              label: pm.getDisplayType(d.type).displayName,
              checked: d.displayId === shownId,
              onClick: function onClick() {
                return self.replaceDisplay(shownId, d.displayId);
              }
            };
          })
        }] : []));
      }
    };
  });
}
exports.createBaseTrackModel = createBaseTrackModel;